import { Fragment, ReactNode } from "react";
import AdminNetworkLayout from "../../components/AdminNetworkSpace/AdminNetworkLayout/AdminNetworkLayout";

function AdminNetworkSpace() {
    return <Fragment></Fragment>;
}

AdminNetworkSpace.getLayout = (page: ReactNode) => (
    <AdminNetworkLayout>{page}</AdminNetworkLayout>
);

export default AdminNetworkSpace;
